import axios from 'axios'
import settings from '@/libs/constant/settings'

// allow query to be made to private api.
// @params: request.endpoint hold the complete url, and not the path like #call
export function apiCaller (request) {
	let method = request.method;
	let url = request.url;
	let body = request.body;
	let params = request.params;
	// user token
	let authorization = request.token || localStorage.getItem('accuraAuthToken');
	const options = {
		method,
		data: JSON.stringify(body),
		url,
		params
	};

	if(request.isImage){
		options.headers = {
			'Content-Type': `image/${request.fileKey.split('.')[1]}`
		}
		options.data = body
	}else{
		options.headers = {
			Authorization : authorization,
			'Content-Type': 'application/json',
			'x-api-key': settings.KEYS[request.service][process.env.VUE_APP_ENV].key
		}
	}

	// this is used only for shorturl to addd user's ip in header
	if (request.headerToBeAdded) {
		options.headers = {...options.headers, ...request.headerToBeAdded}
	}
	
	return axios(options)
		.then((response)=>{
			// refresh token flow
			if(response.headers['x-amzn-remapped-authorization']){
				// set current token
				localStorage.setItem('accuraAuthToken', response.headers['x-amzn-remapped-authorization'])
				// fetch active profile
				let activeProfile = localStorage.getItem('activeProfile')
				// if active profile is present, set auth token with profile id
				if (activeProfile !== null && activeProfile !== undefined && activeProfile !== '') {
					// set token to the current profile selected
					localStorage.setItem(`profile_${activeProfile}`, response.headers['x-amzn-remapped-authorization'] || response.headers['authorization'])
				}
			}
			
			/*
			* set the user's catalogs information into the browser's localStorage, if available.
			* added one check of user_id so that we only store catalog information of the logged-in user
			*/
			if (response.data.catalogs && response.data.catalogs.length > 0 && !body.user_id) {
				localStorage.setItem('catalogs', JSON.stringify(response.data.catalogs))
			}
			return response.data
		}).catch((error)=>{
			throw error.response.data
		})
}
